export function CategoryModel(data) {
    const { id, name, sort, is_delete, reports } = data;
    return {
        id,
        name,
        sort,
        deleted: is_delete,
        reportsCount: reports.length,
    };
}
